export const serviceType = {
  MOWING: 'mowing',
  TREATMENT: 'treatment',
};
